module.exports = __webpack_public_path__ + "fonts/almoni-black-aaa.795acd6.woff";